{
  "Municipal": "Gemeenteraadsverkiezing (GR)",
  "Provincial": "Provinciale Statenverkiezing (PS)",
  "WaterAuthority": "Waterschapverkiezing (WS/AB)"
}
